"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StateLang {
    constructor(country, state, variables, content, insuranceLicenseName = false, insuranceLicenseSignature = false) {
        this.country = country;
        this.state = state;
        this.variables = variables;
        this.content = content;
        this.insuranceLicenseName = insuranceLicenseName;
        this.insuranceLicenseSignature = insuranceLicenseSignature;
    }
    static empty() {
        return new StateLang("", "", []);
    }
}
exports.default = StateLang;
//# sourceMappingURL=stateLang.class.js.map